<template>
	<div class="accordion" role="tablist">
		<div class="accordion-wrap" v-for="(tag, index) in tags" :key="tag._id">
			<div
				:key="index"
				class="d-flex align-items-center accordion-header justify-content-between"
				v-if="tag"
			>
				<div class="d-flex align-items-center">
					<b-badge href="#" variant="link" :style="{ borderColor: tag.color }">{{
						tag.name.charAt(0).toUpperCase()
					}}</b-badge>
					{{ `${tag.name}` }}
				</div>

				<b-dropdown right text="Toggle" variant="link">
					<router-link :to="`/viewTag/${tag._id}`" custom v-slot="{ navigate }">
						<b-dropdown-item @click="navigate">
							<span class="icon">
								<img src="../../../assets/icons/view.svg" alt="view" />
							</span>
							{{ $t('lang.actions.see') }}
						</b-dropdown-item>
					</router-link>

					<b-dropdown-divider></b-dropdown-divider>

					<router-link :to="`/editTag/${tag._id}`" custom v-slot="{ navigate }">
						<b-dropdown-item @click="navigate">
							<span class="icon">
								<img src="../../../assets/icons/edit.svg" alt="edit" />
							</span>
							{{ $t('lang.actions.edit') }}
						</b-dropdown-item>
					</router-link>
				</b-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['tags']
};
</script>

<style scoped></style>
